import moment from 'moment'
import { dataTypes, dateFormats } from '@easybutton/constants'

const DATE_PATTERN = /^\d{4}\-\d{2}\-\d{2}/

export const formatValue = (value, column = {}, emptyPlaceholder = true) => {
  const { dataType, dateFormat, stripeDataType } = column

  if ([null, undefined].includes(value)) {
    if (emptyPlaceholder) {
      return '-'
    } else {
      return null
    }
  }

  if (
    (value && value._seconds) ||
    dataType === dataTypes.DATE ||
    (typeof value === 'string' && value.match(DATE_PATTERN))
  ) {
    let date

    if (dateFormat === dateFormats.SECONDS) {
      date = new Date(value * 1000)
    } else if (value && value._seconds) {
      date = new Date(value._seconds * 1000)
    } else {
      date = new Date(value)
    }

    return moment(date).format('lll')
  }

  if (value && value.label) {
    return value.label
  }

  if (dataType === dataTypes.BOOLEAN || [true, false].includes(value)) {
    return value ? 'YES' : 'NO'
  }

  if (dataType === dataTypes.NUMBER && stripeDataType === 'currency') {
    const num = +value

    return `${value < 0 ? '–' : ''}$${Math.abs(num / 100).toFixed(2)}`
  }

  if (typeof value === 'object') {
    return JSON.stringify(value)
  }

  return String(value)
}
